import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { SwingThemeProvider } from '@theswing/rhythm';
import { QueryClient, QueryClientProvider } from 'react-query';

import FileRoutes from './routes';

import './global.css';
import './locale/i18n';

/**
 * 수정 금지
 */

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SwingThemeProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <FileRoutes />
        </BrowserRouter>
      </QueryClientProvider>
    </SwingThemeProvider>
  </React.StrictMode>
);
